// src/mixins/rentToOwnFormatMixin.js
// FT-173 (финальное ревью, H6/H12): формат денег, процентов, дат и подписи
// enum для компонентов модуля «Аренда с выкупом» и панели договора в
// карточке бронирования. Чистые функции — rentToOwnFormat.js модуля.
import {
  EMPTY,
  moneyToCents,
  centsToMoney,
  formatMoney,
  formatPercent,
  formatDate,
  formatDateTime,
} from "@/components/dashboard/rent_to_own/rentToOwnFormat";

// Миксин для компонентов модуля: валюта из стора, язык из i18n. Оба
// источника необязательны — в юнит-тестах $store и $i18n могут отсутствовать.
export default {
  computed: {
    rtoCurrency() {
      const getters = this.$store && this.$store.getters;
      const company = getters && getters.getCompany && getters.getCompany.company;
      return (company && company.currency) || "";
    },
    rtoLocale() {
      return (this.$i18n && this.$i18n.locale) || undefined;
    },
  },
  methods: {
    fmtMoney(value) {
      return formatMoney(value, { currency: this.rtoCurrency, locale: this.rtoLocale });
    },
    fmtPercent(value) {
      return formatPercent(value, { locale: this.rtoLocale });
    },
    fmtDate(value) {
      return formatDate(value);
    },
    fmtDateTime(value) {
      return formatDateTime(value);
    },
    // H12: подпись значения enum по карте ключей локали; значение вне карты
    // (сервер прислал новое) — нейтральное «—», а не сырой ключ на экране.
    rtoEnumLabel(map, key) {
      return map && map[key] ? this.$t(map[key]) : EMPTY;
    },
    // «Следующий платёж»: дата и остаток к оплате строки (amount − paid_amount);
    // у частично оплаченной строки это меньше суммы строки.
    fmtNextInstallment(installment) {
      if (!installment) return EMPTY;
      const due = moneyToCents(installment.amount) - moneyToCents(installment.paid_amount);
      return `${formatDate(installment.due_on)} · ${this.fmtMoney(centsToMoney(due))}`;
    },
    // «Просрочено»: «3 800 ₽ · 18 дн.»; без просрочки — «—».
    fmtOverdue(contract) {
      if (!contract || !moneyToCents(contract.overdue_total)) return EMPTY;
      const money = this.fmtMoney(contract.overdue_total);
      if (!contract.days_overdue) return money;
      return `${money} · ${contract.days_overdue} ${this.$t("custom.days_short")}`;
    },
  },
};
